import { render, staticRenderFns } from "./DeviceDocumentList.vue?vue&type=template&id=23d5355c&scoped=true"
import script from "./DeviceDocumentList.vue?vue&type=script&lang=js"
export * from "./DeviceDocumentList.vue?vue&type=script&lang=js"
import style0 from "./DeviceDocumentList.vue?vue&type=style&index=0&id=23d5355c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5355c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d5355c')) {
      api.createRecord('23d5355c', component.options)
    } else {
      api.reload('23d5355c', component.options)
    }
    module.hot.accept("./DeviceDocumentList.vue?vue&type=template&id=23d5355c&scoped=true", function () {
      api.rerender('23d5355c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/DeviceDocumentList.vue"
export default component.exports